import { render, staticRenderFns } from "./BusinessSettlement.vue?vue&type=template&id=3d64a5d6&scoped=true"
import script from "./BusinessSettlement.vue?vue&type=script&lang=js"
export * from "./BusinessSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64a5d6",
  null
  
)

export default component.exports